export const RECEIVER_CREATION_TITLE_CUSTOMER = 'NUEVO CLIENTE'
export const RECEIVER_CREATION_TITLE_PROVIDER = 'NUEVO PROVEEDOR'
export const RECEIVER_CREATION_FIELD_1_LABEL='RUT'
export const RECEIVER_CREATION_FIELD_2_LABEL='RAZÓN SOCIAL'
export const RECEIVER_CREATION_FIELD_3_LABEL='GIRO'
export const RECEIVER_CREATION_FIELD_4_LABEL='NOMBRE CONTACTO'
export const RECEIVER_CREATION_FIELD_5_LABEL='DIRECCIÓN'
export const RECEIVER_CREATION_FIELD_6_LABEL='COMUNA'
export const RECEIVER_CREATION_FIELD_7_LABEL='EMAIL'
export const RECEIVER_CREATION_FIELD_8_LABEL='ENVÍA PDF?'
export const RECEIVER_CREATION_FIELD_1_PLACEHOLDER='Ingrese RUT'
export const RECEIVER_CREATION_FIELD_2_PLACEHOLDER='Ingrese razón social'
export const RECEIVER_CREATION_FIELD_3_PLACEHOLDER='Ingrese giro'
export const RECEIVER_CREATION_FIELD_4_PLACEHOLDER='Ingrese nombre de contacto'
export const RECEIVER_CREATION_FIELD_5_PLACEHOLDER='Ingrese dirección'
export const RECEIVER_CREATION_FIELD_6_PLACEHOLDER='Ingrese comuna'
export const RECEIVER_CREATION_FIELD_7_PLACEHOLDER='Ingrese email'
export const RECEIVER_CREATION_FIELD_8_PLACEHOLDER='SI o NO'

export const RECEIVER_CREATION_FIELD_1_NAME='fiscalKey'
export const RECEIVER_CREATION_FIELD_2_NAME='fiscalName'
export const RECEIVER_CREATION_FIELD_3_NAME='category'
export const RECEIVER_CREATION_FIELD_4_NAME='contact'
export const RECEIVER_CREATION_FIELD_5_NAME='address'
export const RECEIVER_CREATION_FIELD_6_NAME='commune'
export const RECEIVER_CREATION_FIELD_7_NAME='mail'
export const RECEIVER_CREATION_FIELD_9_NAME='customerId'
export const RECEIVER_CREATION_FIELD_0_NAME='type'

export const RECEIVER_CREATION_BUTTON_PRIMARY_LABEL='INGRESAR'
export const RECEIVER_CREATION_BUTTON_SECONDARY_LABEL='CANCELAR'

export const RECEIVER_UPLOADER_TITLE_CUSTOMER = 'GESTOR DE CLIENTES'
export const RECEIVER_UPLOADER_TITLE_PROVIDER = 'GESTOR DE PROVEEDORES'
export const RECEIVER_UPLOADER_BUTTON_LABEL_SELECT_FILE = 'Seleccionar Archivo'
export const RECEIVER_UPLOADER_BUTTON_LABEL_PRIMARY_ACTION = 'ACEPTAR'
export const RECEIVER_UPLOADER_BUTTON_LABEL_SECONDARY_ACTION = 'CANCELAR'
export const RECEIVER_UPLOADER_FIELD_NAME = 'file'
